import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import CookieBanner from "@/components/feature/CookieBanner";
import WhatsAppFloat from "@/components/feature/WhatsAppFloat";
import MobileCallBar from "@/components/feature/MobileCallBar";

declare const __BASE_PATH__: string;

export default function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Navbar />
      <div className="pb-16 lg:pb-0">
        <AppRoutes />
        <Footer />
      </div>
      <CookieBanner />
      <MobileCallBar />
      {/* WhatsApp float hidden on mobile since bar handles it */}
      <div className="hidden lg:block">
        <WhatsAppFloat />
      </div>
    </BrowserRouter>
  );
}
